import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import { useAppThemeContext } from '../../contexts';
import { Theme, useTheme } from '@mui/material';

type StyledTooltipProps = TooltipProps & {
    theme: Theme;
    themeName: 'light' | 'dark';
};

const StyledTooltip = styled(({ className, theme, themeName, ...props }: StyledTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, themeName }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.paper,
        color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
        maxWidth: 220,
        border: '1px solid #dadde9',
    },  
}));

export const HtmlTooltip = (props: TooltipProps) => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();

    return <StyledTooltip {...props} theme={theme} themeName={themeName} />;
};